import * as React from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import { is_small_medium_screen } from "src/utils/constants";
import { gr } from "src/design-system/tokens";
import icons from "src/design-system/icons";
import GrIcon from "src/design-system/components/GrIcon";
import GrIconButton from "src/design-system/components/GrIconButton";

export default function CustomPopoverNew({
  isOpenPop,
  is_hide_icon,
  isClosePop = () => {},
  title,
  componentToPassDown,
  heigh,
  width,
}) {
  const handleClose = () => {
    isClosePop(false);
  };

  return (
    <Dialog
      maxWidth="md"
      sx={{
        "@media (max-width: 768px)": {
          ml: 0,
        },
      }}
      open={isOpenPop}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          minWidth: is_small_medium_screen() ? "100%" : width ? width : "950px",
          minHeight: heigh ? heigh : "auto",
        },
        // GymRite Design Elements: dialog look (radius 20, raised shadow, token colours).
        sx: {
          background: gr.color.surface,
          color: gr.color.ink,
          borderRadius: gr.radius.card,
          boxShadow: gr.shadow.raised,
          backgroundImage: "none",
        },
      }}
    >
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: gr.space[3],
            px: gr.space[6],
            pt: gr.space[5],
            pb: gr.space[2],
          }}
        >
          <Box
            component="h2"
            id="alert-dialog-title"
            sx={{
              m: 0,
              fontFamily: gr.font.family,
              fontSize: gr.font.size.xl,
              fontWeight: gr.font.weight.semibold,
              color: gr.color.ink,
            }}
          >
            {title}
          </Box>
          {!is_hide_icon && (
            <GrIconButton
              variant="ghost"
              aria-label="Close"
              onClick={handleClose}
            >
              <GrIcon icon={icons.close} />
            </GrIconButton>
          )}
        </Box>
        <div>{componentToPassDown}</div>
      </Box>
    </Dialog>
  );
}
